import React from 'react';
import { Caption, Text } from '../../../components/atoms/Text/Text';
import { styled } from '../../theme/styled';

const StyledTable = styled.table`
  padding: 0;
  width: 100%;
  border-spacing: 0 ${(props) => props.theme.sizes.xxsmall};
`;

const StyledTh = styled.th`
  text-align: left;
`;

const StyledThBorderTop = styled.th`
  text-align: left;
  border-top: 1px solid ${({ theme }) => theme.palette.grey[400]};
  padding-top: ${(props) => props.theme.sizes.xxsmall};
`;

const StyledTd = styled.td`
  text-align: right;
`;

const StyledTdBorderTop = styled.td`
  text-align: right;
  border-top: 1px solid ${({ theme }) => theme.palette.grey[400]};
  padding-top: ${(props) => props.theme.sizes.xxsmall};
`;

const StyledTr = styled.tr`
  margin-bottom: 0;
`;

export type TableItem = {
  label: string;
  value: string;
};

type TableProps = {
  content: TableItem[];
  summary?: TableItem;
  footerText?: string;
};

export const Table: React.FC<TableProps> = ({ content, summary, footerText }: TableProps) => {
  return (
    <StyledTable>
      <tbody>
        {content.map(({ label, value }) => {
          return (
            <StyledTr key={`${label}-${value}`}>
              <StyledTh>
                <Caption>{label}</Caption>
              </StyledTh>
              <StyledTd>
                <Caption>{value}</Caption>
              </StyledTd>
            </StyledTr>
          );
        })}
        {summary ? (
          <StyledTr key={`${summary.label}-${summary.value}`}>
            <StyledThBorderTop>
              <Text bold>{summary.label}</Text>
            </StyledThBorderTop>
            <StyledTdBorderTop>
              <Text bold>{summary.value}</Text>
            </StyledTdBorderTop>
          </StyledTr>
        ) : null}
      </tbody>
      {footerText ? (
        <tfoot>
          <StyledTr>
            <td colSpan={2}>
              <Text color="secondary">{footerText}</Text>
            </td>
          </StyledTr>
        </tfoot>
      ) : null}
    </StyledTable>
  );
};
